module.exports = __webpack_public_path__ + "img/2024071010212694062v.7613b9bc.jpg";